var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoManufacture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.5181 18.4203C49.9254 13.7499 59.5879 11.0653 69.8719 11V32.1744C68.9712 32.3319 68.1821 32.8141 67.6298 33.4959L41.5181 18.4203Z",
    fill: "#86D5D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100.852 19.4946C109.293 24.5924 116.36 31.7361 121.366 40.2388L103.279 50.6818C102.676 49.9858 101.819 49.5163 100.852 49.4179L100.852 19.4946Z",
    fill: "#A2DADB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9829 37.1628L97.5762 50.7844C98.1288 50.098 98.9208 49.6124 99.8253 49.4542L99.8253 19.271L73.8777 34.2519C74.1031 34.7309 74.2292 35.266 74.2292 35.8306C74.2292 36.3001 74.142 36.7493 73.9829 37.1628Z",
    fill: "#86D5D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70.8989 11.002C81.1404 11.1104 90.759 13.8165 99.127 18.4927L73.3185 33.3933C72.7162 32.702 71.862 32.2358 70.8989 32.1379V11.002Z",
    fill: "#86D5D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1036 34.373L40.9465 19.2712L40.9465 49.418C41.9136 49.5164 42.7708 49.986 43.3736 50.682L67.0069 37.0373C66.8769 36.659 66.8064 36.2532 66.8064 35.8308C66.8064 35.3133 66.9123 34.8206 67.1036 34.373Z",
    fill: "#57C4CB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9236 19.341C31.4054 24.4265 24.2705 31.5887 19.2178 40.1287L37.6745 50.7847C38.2271 50.0983 39.019 49.6126 39.9236 49.4544L39.9236 19.341Z",
    fill: "#57C4CB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7019 41.0145C13.9327 49.4029 11.1518 59.0691 11 69.3722L37.0575 54.3279C36.9252 53.9466 36.8533 53.5371 36.8533 53.1108C36.8533 52.5973 36.9576 52.1081 37.1462 51.6633L18.7019 41.0145Z",
    fill: "#57C4CB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9209 84.0145V56.7672C38.9323 56.5943 38.0783 56.0303 37.5241 55.2406L11.5049 70.2628L37.6578 85.3622C38.211 84.6665 39.0087 84.174 39.9209 84.0145Z",
    fill: "#57C4CB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11 71.1534C11.1518 81.4565 13.9327 91.1227 18.7019 99.5111L37.0649 88.9092C36.9279 88.5219 36.8533 88.1051 36.8533 87.6708C36.8533 87.1652 36.9544 86.6832 37.1375 86.2439L11 71.1534Z",
    fill: "#3299A0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2178 100.397C24.2705 108.937 31.4054 116.099 39.9236 121.184L39.9236 91.3269C38.9426 91.1553 38.0941 90.5987 37.5397 89.8185L19.2178 100.397Z",
    fill: "#3299A0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8719 129.526C59.5879 129.46 49.9254 126.776 41.5181 122.105L67.4944 107.108C68.049 107.883 68.8948 108.436 69.8719 108.607V129.526Z",
    fill: "#3299A0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0863 103.534L43.5154 89.9255C42.9094 90.7168 41.9922 91.2572 40.9465 91.3635L40.9465 121.254L67.0218 106.2C66.8823 105.809 66.8064 105.389 66.8064 104.951C66.8064 104.449 66.9059 103.971 67.0863 103.534Z",
    fill: "#3299A0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M99.127 122.033C90.759 126.709 81.1404 129.415 70.8989 129.523V108.643C71.9406 108.537 72.855 108.001 73.461 107.214L99.127 122.033Z",
    fill: "#037C84"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M97.443 89.8187L73.8979 103.412C74.1117 103.881 74.2307 104.402 74.2307 104.951C74.2307 105.436 74.1376 105.9 73.9681 106.325L99.8269 121.254V91.3271C98.8459 91.1556 97.9974 90.5989 97.443 89.8187Z",
    fill: "#037C84"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M121.366 100.287C116.36 108.789 109.293 115.933 100.852 121.031V91.3635C101.897 91.2572 102.814 90.7168 103.42 89.9255L121.366 100.287Z",
    fill: "#037C84"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M129.514 71.3024C129.339 81.504 126.586 91.0775 121.878 99.3995L103.925 89.0342C104.091 88.6121 104.183 88.152 104.183 87.6706C104.183 87.1179 104.062 86.5934 103.846 86.1221L129.514 71.3024Z",
    fill: "#037C84"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M100.852 70.2628V83.978C101.826 84.0772 102.69 84.5537 103.293 85.2591L129.268 70.2628L100.852 70.2628Z",
    fill: "#037C84"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4097 70.2629L97.5626 85.3623C98.1158 84.6666 98.9135 84.174 99.8257 84.0145V70.2629L71.4097 70.2629Z",
    fill: "#037C84"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1000_19658)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.9844 73.5692V94.6629H119.319L126.453 73.5692H83.9844Z",
    fill: "#092339"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.562 116.173V105.359H124.344V116.173C120.709 117.112 118.016 120.419 118.016 124.344V132.781H122.234V124.344C122.234 122.018 124.127 120.125 126.453 120.125C128.779 120.125 130.672 122.018 130.672 124.344V132.781H134.891V124.344C134.891 120.419 132.198 117.112 128.562 116.173Z",
    fill: "#77AAD4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9844 65L76.3906 83.9825L83.9844 102.969C94.4524 102.969 102.969 94.4524 102.969 83.9844C102.969 73.5164 94.4524 65 83.9844 65Z",
    fill: "#0E3759"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65 83.9844C65 94.4524 73.5164 102.969 83.9844 102.969V65C73.5164 65 65 73.5164 65 83.9844Z",
    fill: "#134A79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9844 137H102.969V126.453L78.3594 120.828L83.9844 137Z",
    fill: "#092339"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65 126.453V137H83.9844V120.828L65 126.453Z",
    fill: "#0E3759"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3594 112.391L83.9844 126.453H102.969L94.5312 118.016L78.3594 112.391Z",
    fill: "#1D71B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9844 112.391L73.4375 118.016L65 126.453H83.9844V112.391Z",
    fill: "#4A8DC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5312 118.016V83.9844H78.3594L83.9844 118.016H94.5312Z",
    fill: "#134A79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9844 83.9844H73.4375V118.016H83.9844V83.9844Z",
    fill: "#1D71B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9844 73.4375L79.7656 83.9834L83.9844 94.5312C89.7999 94.5312 94.5312 89.7999 94.5312 83.9844C94.5312 78.1688 89.7999 73.4375 83.9844 73.4375Z",
    fill: "#1D71B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4375 83.9844C73.4375 89.7999 78.1688 94.5312 83.9844 94.5312V73.4375C78.1688 73.4375 73.4375 78.1688 73.4375 83.9844Z",
    fill: "#4A8DC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.453 73.5692C120.638 73.5692 115.906 78.3005 115.906 84.116V101.141C115.906 106.956 120.638 111.688 126.453 111.688C132.269 111.688 137 106.956 137 101.141V84.116C137 78.3003 132.269 73.5692 126.453 73.5692Z",
    fill: "#1D71B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.453 86.188C127.618 86.188 128.562 85.2436 128.562 84.0786C128.562 82.9136 127.618 81.9692 126.453 81.9692C125.288 81.9692 124.344 82.9136 124.344 84.0786C124.344 85.2436 125.288 86.188 126.453 86.188Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9844 86.0938C85.1494 86.0938 86.0938 85.1494 86.0938 83.9844C86.0938 82.8194 85.1494 81.875 83.9844 81.875C82.8194 81.875 81.875 82.8194 81.875 83.9844C81.875 85.1494 82.8194 86.0938 83.9844 86.0938Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1000_19658"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white",
    transform: "translate(65 65)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoManufacture);
export default __webpack_public_path__ + "static/media/Logo_manufacture.7bebfda0a773ceb393692c4ce67222af.svg";
export { ForwardRef as ReactComponent };